module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.sessionDialog) ? _c('el-dialog', {
    attrs: {
      "title": _vm.$t('ALERT'),
      "visible": _vm.sessionDialog,
      "size": "tiny",
      "close-on-click-modal": false,
      "show-close": false
    },
    on: {
      "update:visible": function($event) {
        _vm.sessionDialog = $event
      }
    }
  }, [(_vm.sessionExpiration == null) ? _c('b', [_vm._v(_vm._s(_vm.$t('SESSIONHASBEENEXPIRED')))]) : _vm._e(), _vm._v(" "), (_vm.sessionExpiration != null) ? _c('el-form', {
    ref: "session",
    attrs: {
      "model": _vm.session,
      "rules": _vm.rules,
      "label-width": "100px",
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t(_vm.message),
      "prop": "pass"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "placeholder": _vm.$t('PLEASEENTERYOURPASSWORD')
    },
    nativeOn: {
      "keyup": function($event) {
        if (!('button' in $event) && _vm._k($event.keyCode, "enter", 13, $event.key)) { return null; }
        _vm.submitForm()
      }
    },
    model: {
      value: (_vm.session.pass),
      callback: function($$v) {
        _vm.$set(_vm.session, "pass", $$v)
      },
      expression: "session.pass"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [(_vm.showTimer()) ? _c('el-button', {
    attrs: {
      "type": "danger",
      "icon": "time"
    }
  }, [_vm._v(_vm._s(_vm.timer))]) : _vm._e(), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        _vm.sessionDialog = false
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('CANCEL')))]), _vm._v(" "), (_vm.sessionExpiration != null) ? _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.loading
    },
    on: {
      "click": _vm.submitForm
    }
  }, [_vm._v(_vm._s(_vm.loading ? _vm.$t('AUTHENTICATING') : _vm.$t('CONFIRM')))]) : _vm._e()], 1)], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-697d0886"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dialogs/Auth.vue
// module id = 611
// module chunks = 1